/**
 * §18.5 — federal deposits that are owed and have no date, because no deposit
 * schedule is recorded for their pay dates (migration 0048).
 *
 * ON HOME AND ON CASHFLOW, FROM ONE COMPONENT. Both lay out a dated list, and a
 * deposit with no date cannot sit in one; left out silently, the list would
 * look lighter by the largest outflow this business has. So both say it here,
 * above the list, in the same words.
 *
 * Rendered only when there is something to say. It names specific pay dates,
 * and a permanent "nothing undated" would be a sentence nobody needs.
 */

import { Link } from 'react-router-dom';
import type { UndatedDeposit } from '../lib/cashflow.js';
import { formatCents } from '../lib/money.js';
import { settingsTab } from '../lib/settings-tabs.js';

export function UndatedDeposits({ deposits }: { deposits: UndatedDeposit[] }) {
  if (deposits.length === 0) return null;
  const one = deposits.length === 1;
  return (
    <div className="notice notice-warn" role="status">
      <strong>Owed, and not dated.</strong>{' '}
      {one ? 'A federal tax deposit has' : `${deposits.length} federal tax deposits have`} no date, because no deposit
      schedule is recorded for the pay date, so {one ? 'it is' : 'they are'} not in the list below or its totals:
      <ul className="missed-list">
        {deposits.map((deposit) => (
          <li key={`${deposit.certainty}-${deposit.firstPayDate}`}>
            {formatCents(deposit.amountCents)} for pay{' '}
            {deposit.lastPayDate === deposit.firstPayDate
              ? `on ${deposit.firstPayDate}`
              : `from ${deposit.firstPayDate} to ${deposit.lastPayDate}`}
            {deposit.certainty === 'projected' && ', if the next run is made then'}
          </li>
        ))}
      </ul>
      <Link to={settingsTab('payroll')}>Record the Deposit Schedule</Link>
    </div>
  );
}
